import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, Tooltip, Typography } from "@mui/material";
import React from "react";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "../../../reducers";
import { NotifMediums } from "../../../enums/notif-types";
import { getAllReadyOpGroupsRequest, getUserReadyOpGroupsRequest, updateUserReadyOpGroupsRequest } from "../../../actions";
import { NotificationGroup } from "../../../reducers/states/user-info";

const EditNotificationPreferences: FC = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [userNotifGroups, setUserNotifGroups] = useState([] as string[])
  const [saveDisabled, setSaveDisabled] = useState(true);

  const userInfoStore = useSelector((state: IRootReducer) => state.userInfoReducer);

  useEffect(() => {
    if (userInfoStore.userReadyOpGroups) {
      setUserNotifGroups(userInfoStore.userReadyOpGroups.map(g => g.id))
    }
  }, [userInfoStore.userReadyOpGroups]);

  const handleOpen = () => {
    dispatch(getUserReadyOpGroupsRequest(userInfoStore.userInfo.email ? userInfoStore.userInfo.email : ""))
    if(!userInfoStore.allReadyOpGroups.length) {
      dispatch(getAllReadyOpGroupsRequest());
    }
    
    setOpen(true);
  };

  const handleNotifGroupChange = (event: ChangeEvent<HTMLInputElement>) => {
    var newGroups = [...userNotifGroups]
    if (event.target.checked === true && newGroups.indexOf(event.target.id) === -1) {
      newGroups.push(event.target.id);
    } else {
      newGroups = newGroups.filter((g) => g !== event.target.id);
    }

    setUserNotifGroups(newGroups);
    setSaveDisabled(false);
  };

  const handleCancel = () => {
    setOpen(false);
    setUserNotifGroups([]);
    setSaveDisabled(true);
  };

  const handleSave = () => {
    dispatch(updateUserReadyOpGroupsRequest(userNotifGroups, userInfoStore.userInfo.email ? userInfoStore.userInfo.email : ""))
    setOpen(false);
    setUserNotifGroups([]);
    setSaveDisabled(true);
  }

  return (
    <>
      <Tooltip title="Edit Notification Preferences within the VCC">
        <Box>
          <Button
            variant="contained"
            color="inherit"
            onClick={handleOpen}
            style={{ minWidth: "150px", color: "black" }}
          >
            Edit Notification Preferences
          </Button>
        </Box>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleCancel}
        fullWidth
        maxWidth="md"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Edit Notification Preferences</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item p={1} xs={12} sm={6}>
              <FormGroup>
                <Typography variant="h5" component="h2">Notify me about</Typography>
                <Typography variant="h6" component="h3">Activities</Typography>
                <Grid container>
                  {
                    userInfoStore.allReadyOpGroups
                      .filter((g) => !g.name.includes("JOG") && !g.name.includes("GROUP") && g.name !== "VCC Incident Created")
                      .sort((g1, g2) => g1.name > g2.name ? 1 : -1)
                      .map((notifGroup: NotificationGroup) => (
                        <Grid key={notifGroup.id} item xs={12}>
                          <FormControlLabel key={notifGroup.id} control={
                            <Checkbox
                              checked={userNotifGroups.includes(notifGroup.id)}
                              id={notifGroup.id}
                              onChange={handleNotifGroupChange}
                            />
                          }
                            label={notifGroup.name}
                          />
                        </Grid>
                      ))
                  }
                </Grid>
              </FormGroup>
              <Typography variant="h6" component="h3">VCC Incident Created</Typography>
              <Grid container>
                {
                  userInfoStore.allReadyOpGroups
                    .filter((g) => g.name.includes("JOG") || g.name.includes("GROUP"))
                    .sort((g1, g2) => g1.name > g2.name ? 1 : -1)
                    .map((notifGroup: NotificationGroup) => (
                      <Grid key={notifGroup.id} item xs={12}>
                        <FormControlLabel control={
                          <Checkbox
                            checked={userNotifGroups.includes(notifGroup.id)}
                            id={notifGroup.id}
                            onChange={handleNotifGroupChange}
                          />
                        }
                          label={notifGroup.name}
                        />
                      </Grid>
                    ))
                }
              </Grid>
            </Grid>
            <Grid item p={1} xs={12} sm={6}>
              <FormGroup>
                <Typography variant="h5" component="h2">Send Notifications Via</Typography>
                <Grid container>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox checked={true} id={NotifMediums.EMAIL} /> // Review: Defaulting to always on since this is the only form of notifs right now
                      }
                      label="Email"
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ margin: "1em" }}>
          <Button onClick={handleCancel} color="inherit" variant="contained">
            Cancel
          </Button>
          <Button
            disabled={saveDisabled}
            onClick={handleSave}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditNotificationPreferences;
